module.exports = __webpack_public_path__ + "static/media/appstore-api-step-3.04c8a590.png";